import React, { useState } from 'react';

const faqs = [
  {
    question: 'What industries does WhyMe Solutions specialize in?',
    answer: 'Our agency serves a wide range of industries, including but not limited to technology, healthcare, real estate, finance, and retail. We leverage our industry-specific knowledge to provide customized solutions that address the unique challenges of each sector.',
  },
  {
    question: 'How do I get started with WhyMe Solutions?',
    answer: 'To get started, simply contact us through our website or by phone to schedule an initial consultation. We will discuss your needs and objectives, and then propose a tailored plan of action to tackle your business challenges.',
  },
  {
    question: 'What makes WhyMe Solutions different from other consulting agencies?',
    answer: 'WhyMe Solutions stands out due to our multidisciplinary approach, offering tailored solutions across various business functions. Our expertise in marketing, HR, IT, and finance allows us to provide comprehensive support that ensures all areas of your business work together synchronously. Moreover, we do not believe in gatekeeping our success measures and so our clients will always be our first priority when it comes to disclosing the best possible practices!',
  },
  {
    question: 'How does WhyMe Solutions ensure the success of its clients?',
    answer: 'We focus on delivering data-driven strategies and personalized solutions to meet your specific needs. Our commitment to continuous improvement, combined with our expertise and dedication, helps drive measurable results and achieve long-term success for our clients.',
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-semibold text-[#13689b] mb-8">Frequently Asked Questions</h2>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#13689b] rounded-xl shadow-xl overflow-hidden transform transition-all hover:scale-105"
            >
              <button
                onClick={() => handleClick(index)}
                className="w-full flex justify-between items-center px-8 py-5 bg-gradient-to-r from-[#13689b] to-[#0a4c63] text-white text-left font-semibold text-lg rounded-t-xl transition-all duration-300 hover:from-[#0a4c63] hover:to-[#13689b]"
              >
                <span>{faq.question}</span>
                <span
                  className={`transform transition-transform duration-300 ${
                    activeIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              {activeIndex === index && (
                <div className="px-8 py-4 bg-white text-black text-base leading-relaxed rounded-b-xl">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
